<script>
  import {API_USER,API_VILLAGE} from '../../common/api'
  import {getFirstNode} from '../../assets/js/funcs'
  import VillageSelect from '../../components/VillageSelect'
  import MyPagination from '../../components/MyPagination'
  import UserAdd from './UserAdd'
  import UserRecharge from './UserRecharge'
  import UserPay from './UserPay'
  import UserUpdate from './UserUpdate'
  import BaseList from '../BaseList'
  import PaySinglePayList from './UserSinglePayList'

  export default {
    name: 'UserList',
    extends: BaseList,
    data() {
      return {
        searchForm: {
          name: '',
          is_pay: null,
        },
        optionProps: {
          value: 'id',
          label: 'name'
        },
        payEnum: [
          {
            label: '已缴费',
            value: 1
          },
          {
            label: '未缴费',
            value: 0
          }
        ],
        selectVillageId: 0,
        rechargeVisible: false,
        payVisible: false,
        payListVisible: false,
      }
    },
    created() {
      // 获取用户列表
      this.getDataList();
      this.getVillageList();
      this.tableHeight = window.innerHeight - 150;
    },
    methods: {
      // 获取用户列表
      getDataList() {
        this.loading = true;
        let params = {
          page_no: this.currentPage,
          page_num: this.pageSize,
          keyword: this.searchForm.name,
          village_id: this.selectVillageId,
          is_pay: this.searchForm.is_pay
        };
        this.$http.GET(API_USER, params,
          res => {
            this.tableData = res.result.list;
            this.totalCount = res.result.total;
            this.loading = false;
          }, err => {
            this.loading = false;
            this.$message.error(err.msg);
          })
      },
      // 小区选择框选择事件
      selectVillage(data) {
        this.selectVillageId = data;
        this.getDataList()
      },

      // 缴费
      pay(id) {
        this.operateId = id;
        this.payVisible = true
      },
      paySuccess() {
        this.payVisible = false;
        this.getDataList()
      },

      // 充值
      recharge(id) {
        this.operateId = id;
        this.rechargeVisible = true
      },
      // 充值成功
      rechargeSuccess() {
        this.rechargeVisible = false;
        this.getDataList()
      },
      // 缴费记录
      selectPayRecord(id) {
        this.operateId = id;
        this.payListVisible = true
      },
      // 打印
      print(user_id, company_id) {
        let routeUrl = this.$router.resolve({
          path: '/api/export/print',
          query: {user_id, company_id}
        });
        window.open(routeUrl.href, '_blank');
      },
    },
    components: {
      VillageSelect,
      MyPagination,
      UserAdd,
      UserRecharge,
      UserPay,
      UserUpdate,
      PaySinglePayList
    }
  }
</script>

<template>
  <div class="main">
    <div class="search_section">
      <el-form :inline="true" :model="searchForm" size="small" @submit.native.prevent>
        <VillageSelect @selectVillageId='selectVillage' :defaultVillageId=0></VillageSelect>
        <el-form-item class="search_item">
          <el-input v-model="searchForm.name" placeholder="用户编号 / 姓名" clearable></el-input>
        </el-form-item>
        <el-form-item class="search_item">
          <el-select v-model="searchForm.is_pay" clearable placeholder="是否缴费" @change="searchData">
            <el-option
              v-for="item in payEnum"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchData">搜索</el-button>
        </el-form-item>
        <el-button type="primary" @click="addDialogVisible = true" size="small" class="add">新增</el-button>
      </el-form>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{background: '#eef1f6', color: '#606266'}"
      highlight-current-row
      size="small"
      :height="tableHeight"
      border
      style="padding: 5px;">
      <el-table-column label="用户编号" prop="number"></el-table-column>
      <el-table-column label="用户名" prop="name"></el-table-column>
      <el-table-column label="手机号" prop="mobile" width="100px"></el-table-column>
      <el-table-column label="门牌号" prop="house"></el-table-column>
      <el-table-column label="上次表数" prop="last_amount"></el-table-column>
      <el-table-column label="抄表数" prop="now_amount"></el-table-column>
      <el-table-column label="用水量" prop="use_amount"></el-table-column>
      <el-table-column label="水费" prop="price"></el-table-column>
      <el-table-column label="水资源税" prop="tax"></el-table-column>
      <el-table-column label="账户余额" prop="balance"></el-table-column>
      <el-table-column label="上次缴费时间" prop="pay_time" width="160px"></el-table-column>
      <el-table-column label="是否缴费" width="70px">
        <template slot-scope="{row}">
          {{ row.is_pay == 1 ? '是' : '否' }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="170px">
        <template slot-scope="{row}">
          <el-tooltip class="operate_item" effect="dark" content="缴费" placement="top">
            <i class="iconfont icon-feiyongtongji1 operate_font" @click="row.is_pay == 1 ? tip('该用户已经缴费') :  pay(row.id)"></i>
          </el-tooltip>
          <el-tooltip class="operate_item" effect="dark" content="缴费记录" placement="top">
            <i class="iconfont icon-jilu1 operate_font" @click="selectPayRecord(row.id)"></i>
          </el-tooltip>
          <el-tooltip class="operate_item" effect="dark" content="充值" placement="top">
            <i class="iconfont icon-icon-test operate_font" @click="recharge(row.id)"></i>
          </el-tooltip>
          <el-tooltip class="operate_item" effect="dark" content="修改" placement="top">
            <i class="iconfont icon-bianji operate_font" @click="showUpdate(row.id)"></i>
          </el-tooltip>
          <el-tooltip class="operate_item" effect="dark" content="打印" placement="top">
            <i class="iconfont icon-dayin1 operate_font" @click="print(row.id, row.company_id)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <MyPagination :totalCount="totalCount" :currentPage="currentPage" @handleSizeChange="handleSizeChange"
                  @handleCurrentChange="handleCurrentChange"></MyPagination>
    <!-- 新增用户 -->
    <el-dialog
      title="新增用户"
      v-if="addDialogVisible"
      :visible.sync="addDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <user-add @addUserSuccess="addSuccess"></user-add>
    </el-dialog>

    <!-- 充值 -->
    <el-dialog
      title="充值"
      v-if="rechargeVisible"
      :visible.sync="rechargeVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body='true'
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <user-recharge :user_id='operateId'
                     @rechargeSuccess="rechargeSuccess"></user-recharge>
    </el-dialog>

    <!-- 缴费 -->
    <el-dialog
      title="缴费"
      v-if="payVisible"
      :visible.sync="payVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body='true'
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <user-pay :user_id='operateId' @closePay="payVisible = false" @paySuccess="paySuccess"></user-pay>
    </el-dialog>

    <!-- 修改用户信息 -->
    <el-dialog
      title="修改用户信息"
      v-if="updateDialogVisible"
      :visible="updateDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body='true'
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="updateDialogVisible = false">
      <user-update :user_id='this.operateId'
                   @updateSuccess="updateSuccess"></user-update>
    </el-dialog>

    <!-- 用户缴费记录 -->
    <el-dialog
      title="用户缴费记录"
      v-if="payListVisible"
      :visible="payListVisible"
      width="80%"
      :modal-append-to-body='false'
      :append-to-body='true'
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="payListVisible = false">
      <PaySinglePayList :user_id='this.operateId'></PaySinglePayList>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>

  @import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/user/UserList.vue